const translations = {
    confirmationText: 'Save',
    description: 'Please select the roles you want to assign to this user',
    notEnoughSeatsError: 'Upgrade your subscription to add more users, all seats are occupied.',
    title: 'Edit User Roles',
    userRolePlaceholder: 'Select User Role',
    userStatusPlaceholder: 'Select User Status'
};

export default translations;
